import * as tslib_1 from "tslib";
import { SceneGraphNode } from "./SceneGraphNode";
import { PartitionBase } from "./PartitionBase";
/**
 * @class away.partition.Partition
 */
var SceneGraphPartition = (function (_super) {
    tslib_1.__extends(SceneGraphPartition, _super);
    function SceneGraphPartition(root) {
        var _this = _super.call(this, root) || this;
        _this._sceneGraphNodePool = new SceneGraphNodePool();
        return _this;
    }
    SceneGraphPartition.prototype.traverse = function (traverser) {
        _super.prototype.traverse.call(this, traverser);
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    SceneGraphPartition.prototype.findParentForNode = function (node) {
        if (this._root == node._entity && node.isSceneGraphNode) {
            this._rootNode = node;
            return null;
        }
        if (!node.isSceneGraphNode && node._entity.isContainer)
            return this._sceneGraphNodePool.getAbstraction(node._entity);
        return this._sceneGraphNodePool.getAbstraction(node._entity.parent);
    };
    SceneGraphPartition.prototype.updateEntity = function (entity) {
        _super.prototype.updateEntity.call(this, entity);
        if (entity.isContainer)
            this.updateNode(this._sceneGraphNodePool.getAbstraction(entity));
    };
    SceneGraphPartition.prototype.clearEntity = function (entity) {
        _super.prototype.clearEntity.call(this, entity);
        if (entity.isContainer)
            this.clearNode(this._sceneGraphNodePool.getAbstraction(entity));
    };
    return SceneGraphPartition;
}(PartitionBase));
export { SceneGraphPartition };
/**
 * @class away.pool.SceneGraphNodePool
 */
var SceneGraphNodePool = (function () {
    function SceneGraphNodePool() {
        this._abstractionPool = new Object();
    }
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    SceneGraphNodePool.prototype.getAbstraction = function (entity) {
        return (this._abstractionPool[entity.id] || (this._abstractionPool[entity.id] = new SceneGraphNode(entity, this)));
    };
    /**
     * //TODO
     *
     * @param entity
     */
    SceneGraphNodePool.prototype.clearAbstraction = function (entity) {
        delete this._abstractionPool[entity.id];
    };
    return SceneGraphNodePool;
}());
export { SceneGraphNodePool };



// WEBPACK FOOTER //
// ../dist/lib/partition/SceneGraphPartition.js